import { Link } from 'react-router-dom'
import { Offcanvas, Button } from 'react-bootstrap'
import { SHOP_LIST_PATH } from '../../../constants/constants'
import SideNavMenuItems from '../../molecules/Shop/SideNavMenuItems'
import WholesaleInfo from '../../molecules/Site/WholesaleInfo'
import { useUserContext } from '../../../context/user/UserProvider'
import { useProductContext } from '../../../context/products/ProductProvider'
import history from '../../../context/history'
import { BsFillMoonFill, BsSunFill } from 'react-icons/bs'

interface IWholesaleOffcanvasProps {
  show: boolean
  handleClose: () => void
}

const WholesaleOffcanvas: React.FC<IWholesaleOffcanvasProps> = ({
  show,
  handleClose,
}) => {
  const { isDarkMode, setDarkMode } = useUserContext()
  const { setPage } = useProductContext()

  const onClickQuickLink = (to: string) => {
    setPage(1)
    history.push(to)

    handleClose()
  }

  const toggleDarkMode = () => {
    setDarkMode(!isDarkMode)
  }

  return (
    <Offcanvas show={show} onHide={handleClose} scroll={true}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          <Link
            to={`/${SHOP_LIST_PATH}`}
            id={`/${SHOP_LIST_PATH}`}
            onClick={() => {
              onClickQuickLink(`/${SHOP_LIST_PATH}`)
            }}
            className="text-decoration-none"
          >
            <div
              className={`pt-2 pb-2 ms-2 ps-2 fs-5 fw-bold ${
                isDarkMode ? 'text-light' : 'text-black'
              }`}
            >
              Wholesale Fireworks
            </div>
          </Link>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <SideNavMenuItems handleClick={handleClose} />
        <Button
          variant={isDarkMode ? 'secondary' : 'primary'}
          onClick={toggleDarkMode}
          className="ms-3 mt-3"
        >
          <span>{isDarkMode ? <BsSunFill /> : <BsFillMoonFill />}</span>
          <span className={'ms-2'}>
            {isDarkMode ? 'Disable ' : 'Enable'} Dark Mode
          </span>
        </Button>
        <WholesaleInfo />
        <div className="ps-3 mt-4">
          <Link
            to="shop.76fireworks.com/contact"
            target="_blank"
            onClick={handleClose}
          >
            Contact Us
          </Link>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  )
}

export default WholesaleOffcanvas
